module.exports = __webpack_public_path__ + "img/9.342a09f0.png";